import { packageDetailSummary } from './packageDisplayText.js';

/** True when a package row should show ticket UI (matches backend Tickets list rules). */
export function packageInvolvesTickets(pkg) {
  if (!pkg) return false;
  return !!(
    pkg.ticketRequired ||
    pkg.ticketDeparture ||
    pkg.ticketDepartureAddon ||
    pkg.ticketReturn ||
    pkg.ticketReturnAddon
  );
}

/** Join-from package, else registration package (same as admin ticket list). */
export function resolveTicketPackageSnapshot(booking) {
  const joinPkg = booking?.joinFromPackage;
  const regPkg = booking?.registration?.package;
  if (packageInvolvesTickets(joinPkg)) return joinPkg;
  if (packageInvolvesTickets(regPkg)) return regPkg;
  return joinPkg || regPkg || null;
}

/** Sub-package line under city/name on Tickets (description, reporting message, or alternate reg package). */
export function ticketPackageSubDetail(booking) {
  const pkg = resolveTicketPackageSnapshot(booking);
  const detail = packageDetailSummary(pkg);
  if (detail) return detail;
  const regPkg = booking?.registration?.package;
  if (!regPkg || String(regPkg.id) === String(pkg?.id)) return '';
  return packageDetailSummary(regPkg) || String(regPkg.name || '').trim();
}

export function bookingInvolvesTickets(booking) {
  if (!booking) return false;
  if (packageInvolvesTickets(resolveTicketPackageSnapshot(booking))) return true;
  return Boolean(booking.batch?.ticketsRequired);
}

/** True when this row has uploaded ticket files (including merged group siblings from list API). */
export function bookingHasTicketFiles(booking) {
  if (!booking) return false;
  if (booking.ticketDownloadUrl) return true;
  const raw = booking.ticketFiles ?? booking.ticket_files;
  if (!raw || typeof raw !== 'object') return false;
  const dep = Array.isArray(raw.departure) ? raw.departure : [];
  const ret = Array.isArray(raw.return) ? raw.return : [];
  const dpnr = String(raw.departurePnr ?? raw.departure_pnr ?? '').trim();
  const rpnr = String(raw.returnPnr ?? raw.return_pnr ?? '').trim();
  return dep.length > 0 || ret.length > 0 || Boolean(dpnr || rpnr);
}
